import { AfterViewInit, Directive, EventEmitter, Output } from "@angular/core";

@Directive({
    selector: "[afterLoad]"
})
export class AfterLoadDirective implements AfterViewInit {
    @Output() readonly afterLoad = new EventEmitter<void>();

    ngAfterViewInit() {
        setTimeout(() => {
            this.afterLoad.emit();
        });
    }
}
